<p-toast></p-toast>

<div class="plan-viewer-container">
  <!-- Header Bar -->
  <div class="plan-viewer-header">
    <div class="header-left">
      <button class="btn-back" type="button" (click)="goBackToPlans()">
        <i class="ri-arrow-left-line"></i>
        <span>All Plans</span>
      </button>
    </div>

    <div class="header-center">
      <h3 class="plan-title">{{ currentPlan?.planName || 'Loading...' }}</h3>
      <span class="page-info">{{ currentPageInfo }}</span>
    </div>

    <div class="header-right">
      @if (isCurrentPlanImage) {
        <p-menu #downloadMenu [model]="downloadMenuItems" [popup]="true" appendTo="body">
          <ng-template pTemplate="item" let-item>
            <a
              class="p-menuitem-link"
              (click)="$event.preventDefault(); $event.stopPropagation(); item.command?.({ originalEvent: $event, item }); downloadMenu.hide()">
              <span [class]="'p-menuitem-icon ' + item.icon"></span>
              <span class="p-menuitem-text">{{ item.label }}</span>
            </a>
          </ng-template>
        </p-menu>
        <button class="btn-outline" type="button" (click)="downloadMenu.toggle($event)" [disabled]="!currentPlan">
          <i class="ri-download-line"></i>
          <span>Download</span>
        </button>
      } @else {
        <button class="btn-outline" type="button" (click)="downloadPlan()" [disabled]="!currentPlan">
          <i class="ri-download-line"></i>
          <span>Download</span>
        </button>
      }
    </div>
  </div>

  <!-- WebViewer Container -->
  <div class="webviewer-wrapper">
    @if (isLoading) {
      <div class="loading-overlay">
        <i class="ri-loader-4-line loading-spinner"></i>
        <p class="loading-text">Loading document...</p>
      </div>
    }
    <div #viewerContainer class="webviewer-container"></div>
  </div>

  <!-- Navigation Buttons -->
  @if (hasPreviousPlan) {
    <button class="nav-button nav-prev" type="button" (click)="goToPreviousPlan()" title="Previous Plan">
      <i class="ri-arrow-left-s-line"></i>
    </button>
  }

  @if (hasNextPlan) {
    <button class="nav-button nav-next" type="button" (click)="goToNextPlan()" title="Next Plan">
      <i class="ri-arrow-right-s-line"></i>
    </button>
  }
</div>
